import { LifecyclePhase, type LifecycleHook } from '@tundr/lifecycle-hooks';
import { useNotificationStore } from './store/notification.store';

export const notificationResetOp: LifecycleHook = {
  name: 'notification:reset',
  fn: () => useNotificationStore().reset(),
  phases: [
    { phase: LifecyclePhase.APP_LAUNCH },
    { phase: LifecyclePhase.LOGOUT },
  ],
};
